import React from 'react'
import TreeView from '@mui/lab/TreeView';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import TreeItem from '@mui/lab/TreeItem';

const DeptTree = ({ nodes, onHandleClick }) => {

  const renderTree = (nodes) => (
    <TreeItem key={nodes.id} nodeId={nodes.id} label={nodes.name}>
      {Array.isArray(nodes.children)
        ? nodes.children.map((node) => renderTree(node))
        : null}
    </TreeItem>
  );

  const onSelectedNode = (event, nodeId) => {
    //console.log(event);
    //console.log(nodeId,'nodeId');
    onHandleClick(nodeId);
  }


  return (
    <TreeView
      aria-label="file system navigator"
      defaultCollapseIcon={<ExpandMoreIcon />}
      defaultExpanded={['root']}
      defaultExpandIcon={<ChevronRightIcon />}
      onNodeSelect={onSelectedNode}
      sx={{ height: 'calc(100vh - 200px)', flexGrow: 1, overflowY: 'auto' }}
    >
      {renderTree(nodes)}
    </TreeView>
  )
}

export default DeptTree